import { Vue } from "vue-property-decorator";
import axios, { AxiosRequestConfig } from "axios";

export const AxiosFactory = new Vue({
  methods: {
    async create() {
      const config: AxiosRequestConfig = {
        baseURL: process.env.VUE_APP_WEBAPI_URL,
        headers: {
          Pragma: "no-cache",
        },
      };

      // const token = localStorage.getItem("vue-authenticate.auth_token");
      const token = await this.$msal.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return axios.create(config);
    },
  },
});
